import React from "react"
import { useQuery } from "@tanstack/react-query";
import { FolderApi } from "../app/api/folder.api";


export function ProfilStats()
{
    const folder = FolderApi();

    const getStats = async () => {
        const {data} = await folder.getStat();
        return data.data;
    };
                 
    const { data } = useQuery({
        queryKey: ["folder-stats"],
        queryFn: getStats,
    });

    return(   
        
        <div className="d-flex flex-column">
                                <div className="d-flex mb-3 py-3 border-bottom px-2 mt-1">
                                    <span className="font-lg text-muted"> Politique de confidentialite </span>       
                                </div>
                                <div className="d-flex flex-column mb-4 p-4 bg-white border rounded-4 scroll">
                                    <span className="text-secondary mb-3"> Nous utilisons vos données uniquement dans le cadre suivant : </span>
                                    <span className="text-secondary mb-1">   - Stockage et organisation de vos documents. </span>
                                    <span className="text-secondary mb-3">   - Amélioration des services via l’IA, assistance et support utilisateur.</span>
                                    <span className="text-secondary mb-3"> Sécurisation des accès et protection contre les abus.</span>
                                    <span className="text-secondary mb-3"> Vos documents sont privés par défaut. Vous pouvez choisir avec qui les partager. </span>
                                    <span className="text-secondary mb-3"> Vous avez : </span>
                                    <span className="text-secondary mb-1">   - Le droit d'accéder à vos données et les télécharger. </span>
                                    <span className="text-secondary mb-1">   - Le controle exclusive sur la gestion de vos informations personnelles, de vos répertoires et documents. </span>
                                </div>
                                <div className="d-flex flex-column mb-3">
                                    <span className="font-lg text-muted px-2 pb-2 border-bottom mb-3"> Statistique </span> 
                                    <div className="row">
                                        <div className="col-md-4 mb-3"> 
                                            <div className="d-flex  border p-3 align-items-center justify-content-center"> 
                                                <div className="d-flex flex-column">
                                                    <span className="h3 text-center text-muted mb-1"> { data?.repositoriesCreated } </span>
                                                    <span className="text-muted text-lead"> Répertoires  </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3"> 
                                            <div className="d-flex  border p-3 align-items-center justify-content-center">
                                                <div className="d-flex flex-column">
                                                    <span className="h3 text-center text-muted mb-1"> { data?.repositoriesShared } </span>
                                                    <span className="text-muted text-lead"> Répertoires partagés  </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3"> 
                                            <div className="d-flex  border p-3 align-items-center justify-content-center"> 
                                                <div className="d-flex flex-column">
                                                   <span className="h3 text-center text-muted mb-1"> { data?.documentsUploaded } </span>
                                                   <span className="text-muted text-lead"> Documents  </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 

    )

}